export default __webpack_public_path__ + "static/media/sc-hat.ff201665.svg";